export default {
  GET_CONTRACTS_LIST: state => state.contracts,
  GET_ONE_CONTRACT: state => state.oneContract,
}
